// extracted by mini-css-extract-plugin
export var copyableItem = "_t-0";
export var underlined = "_t-1";